import { forEach } from 'lodash';
import { Dispatch } from 'react';
import { PaginateListMore } from 'src/app/common/types/common-types';
import { apiClient, apiErrorHandler } from 'src/app/common/network';
import {
  PromotionImageCreateReponse,
  PromotionImageDetail,
  PromotionImageItem,
  PromotionImageListParams,
} from '../types/promotion-image-type';

export const ADMIN_URL = `${window.envConfig['REACT_APP_APIM_BASE_URL']}${window.envConfig['REACT_APP_APIM_ADMIN']}`;

export const create = async (
  data: PromotionImageDetail[],
  dispatch?: Dispatch<any>,
): Promise<PromotionImageCreateReponse> => {
  return apiClient
    .post<PromotionImageDetail>(`${ADMIN_URL}/resource/ad/promotion-images/add`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response: any) => response.data)
    .catch((err: any) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const update = async (
  data: PromotionImageDetail,
  dispatch?: Dispatch<any>,
): Promise<PromotionImageCreateReponse> => {
  return apiClient
    .put<PromotionImageDetail>(`${ADMIN_URL}/resource/ad/promotion-images/edit/${data._id}`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response: any) => response.data)
    .catch((err: any) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const fetchItem = async (id: string, dispatch?: Dispatch<any>): Promise<PromotionImageDetail> => {
  return apiClient
    .get<PromotionImageDetail>(`${ADMIN_URL}/resource/ad/promotion-images/${id}`)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const fetchList = async (
  params: PromotionImageListParams,
  dispatch?: Dispatch<any>,
): Promise<PaginateListMore<PromotionImageItem>> => {
  let queryPath = `${ADMIN_URL}/resource/ad/promotion-images?`;
  forEach(params, (param, key) => {
    queryPath += param ? `${key}=${param}&` : '';
  });

  queryPath = queryPath.substring(0, queryPath.length - 1);

  return apiClient
    .get<PaginateListMore<PromotionImageItem>>(queryPath)
    .then((response: any) => response.data)
    .catch((err: any) => {
      throw apiErrorHandler(err, dispatch);
    });
};
